import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { QuestionCreateComponent } from './question-create/question-create.component';
import { QuestionDetailComponent } from './question-detail/question-detail.component';

const questionsRoutes: Routes = [
  {
    path: 'questions',
    title: 'questions.label',
    children: [
      {
        path: 'new',
        title: 'questions.create',
        component: QuestionCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'questions.create' }
      },
      {
        path: ':id',
        title: ':id',
        component: QuestionDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'questions.detail' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(questionsRoutes)],
  exports: [RouterModule]
})
export class QuestionsRoutingModule {}
